import { retryWhen, mergeMap, delay, catchError, map } from 'rxjs/operators';
import { iif, of, throwError } from 'rxjs';
import * as i0 from '@angular/core';
import { inject, Injectable, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';

function onErrorRetryExpBackoff({ maxRetryAttempts, scalingDuration, includedStatusCodes, } = {
    maxRetryAttempts: 3,
    scalingDuration: 1000,
    includedStatusCodes: [503],
}) {
    return (source) => source.pipe(retryWhen(errors => errors.pipe(mergeMap((error, retryAttempt) => iif(() => retryAttempt + 1 <= (maxRetryAttempts ?? 3) &&
        (includedStatusCodes ?? [503]).some(statusCode => statusCode === error.status), of(error).pipe(delay(getExponentialBackoffDelay(retryAttempt + 1, scalingDuration ?? 1000))), throwError(error))))));
}
function getExponentialBackoffDelay(retryAttempt, scalingDuration) {
    return Math.pow(2, retryAttempt) * scalingDuration;
}

class ZeusService {
    constructor() {
        this.httpService = inject(HttpClient);
    }
    getZones() {
        return this.httpService.get('/zones').pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), catchError(err => throwError(err)));
    }
    getReleases(repo) {
        return this.httpService.get(`/zeus/v2/github/releases/${repo}`);
    }
    getLatestRelease(repo) {
        return this.httpService.get(`/zeus/v2/github/releases/${repo}/latest`);
    }
    getReleaseByTag(repo, tag) {
        return this.httpService.get(`/zeus/v2/github/releases/${repo}/${tag}`);
    }
    getPackageFeatures(name) {
        return this.httpService.get(`/zeus/v2/packages/${name}/features`).pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), catchError(err => throwError(err)));
    }
    getPackages() {
        return this.httpService.get('/zeus/v2/packages?useADS=true').pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), map(({ packages }) => Object.keys(packages).map(key => packages[key])), catchError(err => throwError(err)));
    }
    /** @deprecated */
    getDashboards() {
        return this.httpService.get('/zeus/v2/dashboards').pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), catchError(err => throwError(err)));
    }
    /** @deprecated */
    getDashboard(id) {
        return this.httpService.get(`/zeus/v2/dashboards/${id}`).pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), catchError(err => throwError(err)));
    }
    /** @deprecated */
    createDashboard(data) {
        return this.httpService.post('/zeus/v2/dashboards', data);
    }
    /** @deprecated */
    deleteDashboard(id) {
        return this.httpService.delete(`/zeus/v2/dashboards/${id}`);
    }
    getApplications() {
        return this.httpService.get('/zeus/v2/packages/apps').pipe(onErrorRetryExpBackoff({ maxRetryAttempts: 3, scalingDuration: 1000, includedStatusCodes: [503] }), catchError(err => throwError(err)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ZeusModule {
    static forRoot() {
        return {
            ngModule: ZeusModule,
            providers: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.2", ngImport: i0, type: ZeusModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusModule, providers: [ZeusService] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: ZeusModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [ZeusService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ZeusModule, ZeusService };
